import { render, staticRenderFns } from "./invit.vue?vue&type=template&id=36832418&"
import script from "./invit.vue?vue&type=script&lang=js&"
export * from "./invit.vue?vue&type=script&lang=js&"
import style0 from "./invit.vue?vue&type=style&index=0&id=36832418&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports